import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed, useSuccess } from "features/notification/hooks"
import { manualUpdateGoal } from "features/profile/profileSlice"
import { IManualUpdateGoalPayload } from "features/profile/profileTypes"
import { useNavigate } from "react-router-dom"
import PATHS from "router/paths"

export const useManualUpdateGoal = () => {
  const manualUpdateGoalLoading = useAppSelector(
    (state) => state.profile.manualUpdateGoalLoading,
  )

  const manualUpdateGoalSuccess = useAppSelector(
    (state) => state.profile.manualUpdateGoalSuccess,
  )
  const manualUpdateGoalFailed = useAppSelector(
    (state) => state.profile.manualUpdateGoalFailed,
  )

  const dispatch = useAppDispatch()

  const onUpdateGoalManually = (payload: IManualUpdateGoalPayload) => {
    dispatch(manualUpdateGoal(payload))
  }

  useFailed(manualUpdateGoalFailed)

  const navigate = useNavigate()
  
  useSuccess(manualUpdateGoalSuccess, { message: "" }, () => {
    navigate(PATHS.app.yourGoal.root)
  })

  return {
    manualUpdateGoalLoading,
    manualUpdateGoalSuccess,
    manualUpdateGoalFailed,
    onUpdateGoalManually,
  }
}
